import {Controller} from "./Controller";
import {Flow} from "./initializeFlows";
import {Router} from "../../stem-core/src/ui/Router";
import {iFrameState} from "../services/IFrameState";


export function initPanelDebug() {
    window.Controller = Controller;
    window.Flow = Flow;
    window.Router = Router;
    window.iFrameState = iFrameState;
}
